import React from 'react'


import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import UILoading from "../../../../core/gd-ui/loading/loading"
import AppQuickAdd from "../../quick-add"

import QuickAdd_NewDashboard_CustomDashboardWizard from "./components/custom/custom-dashboard-wizard";
import {DashboardTemplateConfig} from "../../../../core/gd-modules/dashboard/templates/templates-custom";
import Template from "../../../../core/model2/template/template";
import QuiqAdd_NewDashboard_SelectDashboardProjectForm from "./components/project/select-project-form";
import QuickAdd_NewDashboard_SelectCustomDashboardTemplate from "./components/custom/select-template";
import QuickAdd_NewDashboard_SelectProjectDashboardTemplate from "./components/project/select-template";
import QuickAdd_NewDashboard_SelectType from "./components/select-type/select-type";

export enum NewDashboard_SelectedType {
    CUSTOM      = 'custom',
    PROJECT     = 'project',
    USER        = 'user',
}

type Props = {
    app         : AppQuickAdd
    initParams  : any
}

type State = {
    selectedType        : NewDashboard_SelectedType | null,

    initParams?         : any

    gdTemplate?         : DashboardTemplateConfig // "goodday" template with data ... if selected
    myTemplate?         : Template  // if selected
}

export default class NewDashboardMain extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            selectedType: props.initParams ? props.initParams.type : null,
            gdTemplate  : undefined,
            myTemplate  : undefined,
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State, snapshot: any) {
        if (!_.isEqual(this.props.initParams, prevProps.initParams) &&
            this.state.selectedType !== prevState.selectedType) {
            this.setState({
                selectedType: null,
            })
        }
    }

    onSelectType = (viewId: any | null) => {
        this.setState({
            selectedType: viewId.typeId
        })
    }

    renderLoading() {
        return (
            <VScroll className="new-main customer">
                <UILoading size="normal" message="Loading..." />
            </VScroll>
        )
    }

    render() {

        if (this.state.gdTemplate && this.state.selectedType === NewDashboard_SelectedType.PROJECT) {
            return <QuiqAdd_NewDashboard_SelectDashboardProjectForm
                parent          = {this}
                gdTemplate      = {this.state.gdTemplate}
                initParams      = {this.props.initParams}
            />
        }

        if (this.state.gdTemplate && this.state.selectedType === NewDashboard_SelectedType.CUSTOM) {
            return <QuickAdd_NewDashboard_CustomDashboardWizard
                parent          = {this}
                gdTemplate      = {this.state.gdTemplate}
                initParams      = {this.props.initParams}
            />
        }

        if (this.state.myTemplate?.isProjectDashboard) {
            return <QuiqAdd_NewDashboard_SelectDashboardProjectForm
                parent          = {this}
                myTemplate      = {this.state.myTemplate}
                initParams      = {this.props.initParams}
            />
        }

        // if (this.state.myTemplate?.isCustomDashboard) {
        //     return <QuickAdd_NewDashboard_CustomDashboardWizard
        //         parent          = {this}
        //         myTemplate      = {this.state.myTemplate}
        //         initParams      = {this.props.initParams}
        //     />
        // }


        if (this.state.selectedType === NewDashboard_SelectedType.CUSTOM) {
            return <QuickAdd_NewDashboard_SelectCustomDashboardTemplate
                app             = {this}
                initParams      = {this.props.initParams}
            />
        }

        if (this.state.selectedType === NewDashboard_SelectedType.PROJECT) {
            return <QuickAdd_NewDashboard_SelectProjectDashboardTemplate
                app             = {this}
                initParams      = {this.props.initParams}
            />
        }

        return <QuickAdd_NewDashboard_SelectType
            onSelectDashboardType        = {this.onSelectType}
        />
    }
}